import React, { useEffect, useState, useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Layout, Button, Collapse, Drawer, FloatButton, Tour  } from 'antd';
import type { CollapseProps, TourProps } from 'antd';
import { SettingOutlined } from '@ant-design/icons';
import './style.css';
import CheckLoginPage from '../CheckLoginPage/CheckLoginPage';
import MobileLayout from '../../layouts/MobileLayout';
import Attractions from '../../components/Attractions'
import AttractionsV2 from '../../components/AttractionsV2'
import Itinerary from '../../components/Itinerary'
import AllTagsDrawer from '../../components/AllTagsDrawer'
import AllTagsCollapse from '../../components/AllTagsCollapse'
import ItineraryCollapse from '../../components/ItineraryDrawer'
// import LandingAskModal from '../..//components/LandingAskModal'
import LandingAskModalV2 from '../..//components/LandingAskModalV2'
import LeafletMap from '../../components/LeafletMap';
import Tag from '../../types/Tag';
import { useQuery, QueryCache } from 'react-query';
// 自動定位相關組件
import AutoLocationTrigger from '../../components/AutoLocationTrigger';
// import { AttractionType } from '../../types/ItineraryType';
import TagService from '../../apis/TagService';
import AttractionService from '../../apis/AttractionService';
//google map
// import MapComponent from '../../components/MapComponent';
// import MapComponent, { GmapHandler } from '../../components/MapComponent';
// import Gmap from '../../components/MapComponent';
import QuizService from '../../apis/QuizService';
import { faRectangleList } from '@fortawesome/free-solid-svg-icons';
import ItineraryService from '../../apis/ItineraryService';
import { IS_MOBILE_LOGIN,ORIGINAL_URL,COOKIE_NAME,COOKIE_LOGUT_NAME } from '../../configuration'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLocationArrow, faHouse, faHashtag, faMap, faStreetView, faQuestion } from '@fortawesome/free-solid-svg-icons';
import { devLog } from '../../utils/devLogger';
import { handleLineLogin } from '../../utils/lineAuthUtils';
import { DEBUG_MODE } from '../../config/debug';
import { getYjTokenAndStatus,enableTour } from '../../apis/member';
import { YJ_ACCESS_TOKEN, USER_INFO_KEY } from '../../configuration'
import jwt_decode from 'jwt-decode';
import AuthContext from '../../context/authContext'; //內文
interface TokenPayload {
  sub: string;  //TODO
  name: string;
  picture: string;
}
import { useNavigate } from 'react-router-dom';
import { UserInfoContext } from '../../context/userInfoContext';
import { MapInfoContext } from '../../context/mapInfoContext';
//處理結果
import { ProcessMapData, ResetMapData } from '../../lib/MapLib';
import { AttractionData, ItineraryDetailType, AuthInfoData, LocationData } from '../../types/CustomType';
import MapComponent_v2 from '../../components/MapComponent_v2';

import UserService from '../../apis/UserService';
import { GetUserLocationInfo } from '../../lib/MapLib';
const { Footer } = Layout;
const { Panel } = Collapse;


type RouteParams = {
  attractionName : string | undefined;
  itineraryUUID : string | undefined;
  itineraryName : string | undefined;
};



const MobilePage = () => {

  const {attractionName,itineraryUUID,itineraryName} = useParams<RouteParams>();

  const [isSingle, setIsSingle] = useState<boolean>(false);


  const [isLandingAskOpen, setIsLandingAskOpen] = useState<boolean>(false);
  const [debugMsg, setDebugMsg] = useState<string>('init');
  const [hasAutoLocationTriggered, setHasAutoLocationTriggered] = useState<boolean>(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [drawerView, setDrawerView] = useState('attractions');
  const [customized, setCustomized] = useState<boolean>(false);
  const [collapseView, setCollapseView] = useState('allTagsCollapse');
  const [drawerTitle, setDrawerTitle] = useState('');
  const [showCollapse, setShowCollapse] = useState<boolean>(false);
  const [collapseTitle, setCollapseTitle] = useState('');
  const [isMyLocation, setMyLocation] = useState<boolean>(false);
  const [collapseItineraryId, setCollapseItineraryId] = useState('');
  // const [attrActionsByItinerary, setAttractionsByItinerary] = useState<AttractionData[]>([]);
  const [itinerary, setItinerary] = useState<ItineraryDetailType>();
  const [clusterAttractions, setClusterAttractions] = useState<AttractionData[]>([]);
  const [tags, setTags] = useState<Tag[]>([]);
  const [tagID, setTagID] = useState('');
  const [collapseActiveKey, setCollapseActiveKey] = useState(['1']);
  const [stepOpen, setStepOpen] = useState<boolean>(false);
  const [mualStepOpen, setMualStepOpen] = useState<boolean>(false);
  const locationRef = useRef(null);
  const tagsRef = useRef(null);
  const attractionRef = useRef(null);
  const customPathRef = useRef(null);
  //const [tagID_, setTagID_] = useState('');


  const [tagName, setTagName] = useState('');
  // const [searchParams, setSearchParams] = useSearchParams();
  // const [mapMode, setMapMode] = useState<boolean>(false);

  const [randomValue, setRandomValue] = useState<number>(0);


  const mapContext = useContext(MapInfoContext);
  const userContext = useContext(UserInfoContext);
  // const gmapRef = React.useRef<GmapHandler>(null);
  //Liff
  // const [displayName, setDisplayName] = useState('');

  const [lineToken, setLineToken] = useState<string>('');

  // 由下往上滑的 Panel 

  const [isOpenPanel, setIsOpenPanel] = useState<number>(0);

  const handlePanelToggle = () => {
    if(isOpenPanel == 0) {
      setIsOpenPanel(1);
    } else {
      setIsOpenPanel(0);
    }
    
  };

  const showDrawer = (title: string, view: string, customized = false) => {
    setDrawerTitle(title);
    setDrawerView(view);
    setCustomized(customized);

    // if(customized && !userContext.quizDone) {
    //   //取得該使用者最後一次測驗的資料
    //   devLog("客製化行程要查詢!!!")
    //   getMyQuizResultEvent();
    // } else {
    //   setOpenDrawer(true);
    // }
    setOpenDrawer(true);
    // openDrawer ? "" : setOpenDrawer(true);
    
  };

  const onCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const closeCollapsePanel = () => {
    setCollapseActiveKey([]);
  };


  const openCollapse = (title: string, view: string) => {
    //devLog("[openCollapse] view name = "+view);
    setCollapseView(view);
    setCollapseTitle(title);
    showCollapse ? "" : setShowCollapse(true);
  };

  const onAllInineraryDrawer = () => {
    setOpenDrawer(false);
    showDrawer('所有經典路線', "itinerary");
    setIsOpenPanel(0);
    setOpenDrawer(true);
  };

  const openAllTagCollapse = (title: string, view: string) => {
    devLog("[openAllTagCollapse] view name = "+view);
    setCollapseView(view);
    setCollapseTitle(title);
    setIsOpenPanel(0);
    showCollapse ? "" : setShowCollapse(true);
    
  };

  //預設首頁
  // const openLandingAskModalCollapse = (title: string, view: string, tagID: string) => {
  //   //devLog("[openCollapse] view name = "+view);
  //   setCollapseView(view);
  //   setCollapseTitle(title);
  //   setTagID(tagID);
  //   showCollapse ? "" : setShowCollapse(true);

  // };


  const navigate = useNavigate();

  const authCtx = useContext(AuthContext);




  const generateRandomString = (length: number): string => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return result;
  };

 

  


  const enableTourEvent = async (enable : any)  => {

    try {
        const updatePayload = {
            "tour_check": enable, 
        };

        await enableTour(updatePayload)
        .then((response) => {
       
            // devLog("[qrcode] success response: ", response?.data);
            
        })
        .catch((error) => {
            // devLog("[qrcode] error response: ", error);
           
        });

        authCtx.updateUserInfo();
     
     

    }
    catch (error) {
        devLog('post qr code error:', error);
    }
  }




  

  useEffect(() => {

    if (typeof authCtx.isMobileLogin === 'boolean' && !authCtx.isMobileLogin) {
      localStorage.setItem(ORIGINAL_URL, "/mobile");
      handleLineLogin((yjToken) => {
        authCtx.setMobileLogin(true);
      });
    } else {
      authCtx.updateUserInfo();
    }


    if (userContext.quizDone == true) {
          // devLog("客製化路線");
          setIsLandingAskOpen(false)
          if (userContext.quizDoneFirstChecked == true) {
            showDrawer('客製化路線景點介紹', 'attractions_path', true);

            recodeQuizResultEvent(userContext.recordQuizUUID,userContext.recordQuizAttractions,userContext.recordQuizAnwser);
            userContext.setQuizDoneFirstCheckedStatus(false);
          }
        
        }
    else {

      if(attractionName != undefined && attractionName != ''){
        setIsLandingAskOpen(false)
        setIsSingle(true)
      } else {
        setIsSingle(false)
        setIsLandingAskOpen(true)
      }


      if(itineraryUUID != undefined && itineraryUUID != '' && itineraryName != undefined && itineraryName != ''){
        setIsLandingAskOpen(false)
        openItineraryCollapse(itineraryName, 'itineraryCollapse', itineraryUUID);
      } else {
        setIsLandingAskOpen(true)
      }

      if (tagID == "") {
        ResetMapData(mapContext);//重置所有地圖上資訊

        // queryAttractionByTag();
        // devLog("itineraryUUID ="+itineraryUUID);
        if(itineraryUUID == undefined ){
          newQueryAttractionByTag(tagID);
        }
        // newQueryAttractionByTag(tagID);
      }
        
    }

  
  }, [location.pathname]);//tagID,

  useEffect(() => {
    // devLog("Tag 變化");
    if (tagID != "") {
      setIsOpenPanel(0);
      // queryAttractionByTag();
      newQueryAttractionByTag(tagID);
    }
  }, [tagID]);

  

  //紀錄個人行程
  const recodeQuizResultEvent = async (quiz_uuide:string,attractions:string,description:string)  => {

    try {
        const updatePayload = {
            "quiz_uuid":quiz_uuide, 
            "attractions":attractions,
            "description":description,
        };

        // devLog("quiz_uuid: "+userContext.recordQuizUUID);
        // devLog("description: "+description);
        // devLog("attractions: "+attractions);

        await QuizService.recodeQuizData(updatePayload)
        .then((response) => {
       
            //devLog("[recodeQuizResultEvent] success response: ", response?.data);

            // userContext.recordQuizUUID = "";
            // userContext.recordQuizAttractions = "";
            // userContext.recordQuizAnwser = "";

          userContext.setRecordQuizUUID("");
          userContext.setRecordQuizAnwser("");
          userContext.setRecordQuizAttractions("");
            
        })
        .catch((error : any) => {
           //devLog("[recodeQuizResultEvent] error response: ", error);
           
        });

    }
    catch (error) {
        //devLog('post qr code error:', error);
    }
  }

  //取得最後一筆個人客製化行程
  const getMyQuizResultEvent = async ()  => {

    try {
        

        await QuizService.getLastQuizDoneData()
        .then((response) => {

          if(response){
            // devLog("最後一筆資料的景點數量: ", response.length);
            ProcessMapData(mapContext,response, true);
            setOpenDrawer(true);
          }
       
          
            
        })
        .catch((error : any) => {
           //devLog("[recodeQuizResultEvent] error response: ", error);
           
        });

    }
    catch (error) {
        //devLog('post qr code error:', error);
    }
  }

  const openItineraryCollapse = (title: string, view: string, uuid: string) => {

    // devLog("觸發 openItineraryCollapse [顯示路徑的景點]");

    // mapContext.setInIsUpdate(false);

    if(collapseItineraryId != uuid) {
      mapContext.setInIsUpdate(false);
    }
    setShowCollapse(false);
    setCollapseView(view);
    setCollapseTitle(title);
    setCollapseItineraryId(uuid);
    // devLog("景點數量 :"+mapContext.attraction.length);
    // queryItineraryDetailInfo()
    showDrawer(title, 'attractions_path', false);
    // devLog("[openItineraryCollapse] view ="+view+" title = "+title);
  };

  const showAllAttractionByItineraryDrawer = (title: string | null, view: string, data: AttractionData[] | null) => {

    // devLog("觸發 showAllAttractionByItineraryDrawer");

    title ? setDrawerTitle(title) : setDrawerTitle("");
    setDrawerView(view)
    // data ? setAttractionsByItinerary(data) : setAttractionsByItinerary([]);
    // mapContext.setInIsUpdate(false);
    openDrawer ? "" : setOpenDrawer(true);

    if (data) {
      
      ProcessMapData(mapContext, data, true);  //這裡才會是更新玩
    }

  };


  const showAttractionsDrawer = (title: string | null, view: string, tagID: string) => {
  //  devLog("[showAttractionsDrawer] title = " + title);
    title ? setDrawerTitle(title) : setDrawerTitle("");
    setTagID(tagID);
    setDrawerView(view);
    // queryAttractionByTag();
    //  devLog("tag id--> " + tagID);
     openDrawer ? "" : setOpenDrawer(true);

  };

  const handleShowClusterAttractions = (attractions: AttractionData[], title: string) => {
    setClusterAttractions(attractions);
    setDrawerTitle(title);
    setDrawerView('cluster_attractions');
    setOpenDrawer(true);
  };

  const [district, setDistrict] = useState('');
  const newQueryAttractionByTag = async (tagID: string) => {
  try {
    const apiKey = 'AIzaSyAP0Ij24_Z323jesR6lBlXKowmHjJKoXcQ';

    setDebugMsg('取得位置中...');
    let city = "";
    let district = "";

    const location = await GetUserLocationInfo(apiKey);

    if (location) {
      city = location.city;
      district = location.district;
      setDebugMsg(`位置OK(${city}${district}) 查詢景點...`);
    } else {
      setDebugMsg('位置超時/失敗，用空值查景點...');
    }

    const response = await AttractionService.getDataByArea(tagID, city, district);

    if (response?.length !== 0) {
      setDebugMsg(`景點${response.length}筆 ✅`);
      if (tagID !== "") {
        showDrawer(`關鍵字瀏覽: #${tags[parseInt(tagID) - 1].name}`, "attractions");
      }
      ProcessMapData(mapContext, response, false);
    } else {
      setDebugMsg('景點0筆');
      ResetMapData(mapContext);
    }

  } catch (error: any) {
    setDebugMsg(`景點API錯誤: ${error?.message ?? String(error)}`);
  }
}


  //最佳解
  // const { refetch: queryAttractionByTag } = useQuery<AttractionData[], Error>(

  //   `queryKey${tagID}`,
  //   async () => await AttractionService.getData(tagID),
  //   {
  //     enabled: !!tagID,
  //     onSuccess: (res) => {
  //       // drawerTitle

  //       setDrawerTitle(collapseTitle);
  //       devLog("有變化:" + res?.length +" 顯示種類"+drawerView);
  //       // setAttractionsByItinerary(res);
  //       if (res?.length != 0) {

  //         if (tagID != "")
  //           openDrawer ? "" : setOpenDrawer(true);
          
  //         ProcessMapData(mapContext, res, false);
  //         // setIsSingle(false);
  //         setDrawerView("attractions");

  //       } else {
  //         ResetMapData(mapContext);
  //       }
  //     }
  //   }
  // );


  const { refetch: queryItineraryDetailInfo } = useQuery<ItineraryDetailType, Error>(

    `queryKey-${collapseItineraryId}`,
    async () => await ItineraryService.findAppoint(collapseItineraryId),
    {
      enabled: !!collapseItineraryId,
      onSuccess: (res) => {
        setItinerary(res);
        const markDataLocation = res?.way_attractions;
        if (markDataLocation) {
          // ResetMapData(mapContext);
          // devLog("[更新路城資訊]")
          ProcessMapData(mapContext, markDataLocation, true);
        }
        if (collapseItineraryId != "") {
          showCollapse ? "" : setShowCollapse(true);
          // devLog(res.way_attractions);
          // ProcessMapData(mapContext,data,true);
        }
        // showCollapse ? "" : setShowCollapse(true);
      }
    }
  );

  const genExtra = () => (
    <div className="flex items-center">
      <button className=' text-primary border-primary border rounded-lg bg-white mt-1' >
        <FontAwesomeIcon icon={faRectangleList} className='mr-1' />
        查看詳細資訊
    </button>
    </div>
    
  );

  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: collapseTitle,
      showArrow: true,
      extra: genExtra(),
      children:
        <>
          {collapseView === 'allTagsCollapse' && 
          <AllTagsCollapse setCollapseTitle={setCollapseTitle} 
            showAttractionsDrawer={showAttractionsDrawer} 
            showItinerariesDrawer={showDrawer} 
            setTagID_={setTagID} 
            tags={tags} 
            tagName={tagName} 
            _tagID={tagID} />
          }
          {collapseView === 'itineraryCollapse' && <ItineraryCollapse showDrawer={showAllAttractionByItineraryDrawer} openCollapse={openCollapse} itinerary_={itinerary} /> }
        </>
      // children: <AllTagsCollapse setCollapseTitle={setCollapseTitle} showDrawer={showDrawer} />,

    }
  ]
  const onChange = (key: string | string[]) => {
    // devLog(key);
    if(isOpenPanel == 0) {
      setIsOpenPanel(1);
    } else {
      setIsOpenPanel(0);
    }
  };


  //tag------------------------------------------------------
  const { isLoading, isSuccess, isError, data } = useQuery<any, Error>(
    ["query-default-tags"],
    async () => {
      return await TagService.findDefault();
    },
    {
      keepPreviousData: true,
      onSuccess: (res) => {
        setTags(res.message);
      },
      onError: (err: any) => {
        devLog(err);
      }
    }
  );


  const steps: TourProps['steps'] = [
    {
      title: '定位',
      description: '定位您所在位置.',
      placement: 'left',
      nextButtonProps: {
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },
      target: () => locationRef.current,
    },
    {
      title: '所有標籤分類',
      description: '查看所有標籤分類',
      placement: 'left',
      nextButtonProps: {
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },
      prevButtonProps:{
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },
      target: () => tagsRef.current,
    },
    {
      title: '所有經典路線',
      description: '查看所有經典路線',
      placement: 'left',
      prevButtonProps:{
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },nextButtonProps: {
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },
      target: () => attractionRef.current,
    },
    {
      title: '所有客製化路線',
      description: '查看所有客製化路線',
      placement: 'left',
      prevButtonProps:{
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },nextButtonProps: {
        style:{
          backgroundColor:'#179188',
          color:'#FFFFFF',
        }
      },
      target: () => customPathRef.current,
    },
  ];

  

  return (
    
   
    <>
      { 
      
      <MobileLayout>
        {/* ── DEBUG BANNER：由 src/config/debug.ts 的 DEBUG_MODE 統一控制 ── */}
        {DEBUG_MODE && <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999, background: '#ff0', color: '#000', fontSize: 11, padding: '2px 6px', wordBreak: 'break-all' }}>
          🐛 LINE={/Line\//i.test(navigator.userAgent) ? 'YES' : 'NO'} | login={String(authCtx.isMobileLogin)} | token={localStorage.getItem('yj-access-token') ? '有' : '無'} | {debugMsg}
        </div>}
        {/* ── END DEBUG BANNER ── */}
        {/* 自動定位觸發元件 */}
        <AutoLocationTrigger
          onLocationUpdate={(location) => {
            devLog('📍 MobilePage: 收到位置更新', {
              來源: location.source,
              座標: `${location.lat}, ${location.lng}`,
              精度: location.accuracy ? `${location.accuracy}m` : '未知'
            });
            setHasAutoLocationTriggered(true);
          }}
          enabled={true}
          delay={1500}
        />
       
      <div
        className='w-full bg-white flex flex-grow h-full relative'
      >
        {!authCtx.userInfo.tour_check && authCtx.isMobileLogin  ?
          
          <Tour 
            open={stepOpen} 
            steps={steps} 
            onClose={() => authCtx.isLogin && enableTourEvent(!authCtx.userInfo.tour_check) }
          />
          :
          <Tour 
            open={mualStepOpen} 
            steps={steps} 
            onClose={() => setMualStepOpen(false) }
          />
        }
       
        <Drawer title={drawerTitle} placement="right" onClose={onCloseDrawer} open={openDrawer} >
          {drawerView === 'itinerary' && <Itinerary onClose={onCloseDrawer} openCollapse={openItineraryCollapse} />}
          {drawerView === 'attractions' && <Attractions data={mapContext.attraction} />}
          {drawerView === 'attractions_path' && customized !== true && <AttractionsV2 data={mapContext.attraction} customized={false} lodaing={false} randomForCustom={0} />}
          {drawerView === 'attractions_path' && customized === true && <AttractionsV2 data={mapContext.attraction} customized={true} lodaing={!userContext.quizDone} randomForCustom={randomValue}/>}
          {drawerView === 'cluster_attractions' && <Attractions data={clusterAttractions} />}
          {drawerView === 'allTagsDrawer' && <AllTagsDrawer onClose={onCloseDrawer} openCollapse={openAllTagCollapse}  onAllInineraryDrawer={onAllInineraryDrawer} setTagID={setTagID} />}
        </Drawer>

        {/* {isError && <div>失敗</div>} */}
        {/* {isSuccess && <LandingAskModal isLandingAskOpen={isLandingAskOpen} setIsLandingAskOpen={setIsLandingAskOpen} openCollapse={openLandingAskModalCollapse} tags={tags}/>} */}
        {isLandingAskOpen &&
          <LandingAskModalV2 setIsLandingAskOpen={setIsLandingAskOpen} openCollapse={openCollapse} openItineraryCollapse={openItineraryCollapse} tags={tags} setTagID={setTagID} setStepOpen={setStepOpen} />
        }
        {/* {isLoading && <div>載入</div>} */}

        <div className='flex justify-center items-center font-semibold flex-grow'>
          {/* <LeafletMap /> */}
          <MapComponent_v2  attractions={mapContext.attraction} isDrawOrder={mapContext.isDrawPath} triggerCurrent={isMyLocation} setMyLocation={setMyLocation} triggerSingle={isSingle} singleName={attractionName} onShowClusterAttractions={handleShowClusterAttractions} />
         
          <div className='flex justify-center items-center font-semibold flex-grow '>
          
            <Layout className='map-title bg-transparent w-full'>
              <div className=' text-primary text-4xl pt-20 relative'>
                <Button
                  shape='circle'
                  ref={locationRef}
                  className=' bg-[#FFD653] absolute top-[80px] right-[10px] transition hover:ease-in-out hover:scale-150 '
                  icon={<FontAwesomeIcon icon={faLocationArrow} style={{ color: "#ffffff", backgroundColor: "#FFD653" }} onClick={() => { 
                    setIsOpenPanel(0);
                    setMyLocation(!isMyLocation) 
                  }} />}
                />
            
                <Button
                  shape='circle'
                  ref={tagsRef}
                  className=' bg-[#EB9267] absolute top-[120px] right-[10px] transition hover:ease-in-out hover:scale-150'
                  icon={<FontAwesomeIcon icon={faHashtag} style={{ color: "#ffffff", backgroundColor: "#EB9267" }} />}
                  onClick={() => {
                    setIsOpenPanel(0);
                    showDrawer('所有分類', 'allTagsDrawer');
                  }}
                />
                <>
                <Button
                  shape='circle'
                  ref={attractionRef}
                  className=' bg-[#037ef3] absolute top-[160px] right-[10px]  transition hover:ease-in-out hover:scale-150'
                  icon={<FontAwesomeIcon icon={faMap} style={{ color: "#ffffff", backgroundColor: "#037ef3" }}
                    onClick={() => {
                      setIsOpenPanel(0);
                      showDrawer('所有經典路線', "itinerary");
                    }} />}
                />
                </>
                <>
                <Button
                    shape='circle'
                    ref={customPathRef}
                    className=' bg-[#74d2e7] absolute top-[200px] right-[10px] transition hover:ease-in-out hover:scale-150 '
                    icon={<FontAwesomeIcon icon={faStreetView} style={{ color: "#ffffff", backgroundColor: "#74d2e7" }} />}
                    onClick={() => {  
                      //devLog("我按了客製化路線景點介紹")
                      userContext.setQuizDoneStatus(false);
                      mapContext.setInIsUpdate(false);
                      // ResetMapData(mapContext);
                      setRandomValue(Math.random());
                      // ProcessMapData(mapContext, userContext.quizMapResult, true);
                      showDrawer('客製化路線景點介紹', 'attractions_path', true);
                    }}
                  />
                </>
                <>
                <Button
                  shape='circle'
                  
                  className=' bg-[#9D9D9D] absolute top-[240px] right-[10px]  transition hover:ease-in-out hover:scale-150'
                  icon={<FontAwesomeIcon icon={faQuestion} style={{ color: "#ffffff", backgroundColor: "#9D9D9D" }}
                    onClick={() => {
                      setIsOpenPanel(0);
                      setMualStepOpen(true);
                      
                    }} />}
                />
                </>
                
                {/* {
                  userContext.quizDone == true && <Button
                    shape='circle'
                    className=' bg-[#74d2e7] absolute top-[200px] right-[10px] transition hover:ease-in-out hover:scale-150 '
                    icon={<FontAwesomeIcon icon={faStreetView} style={{ color: "#ffffff", backgroundColor: "#74d2e7" }} />}
                    onClick={() => {
                      ProcessMapData(mapContext, userContext.quizMapResult, true);
                      showDrawer('客製化路線景點介紹', 'attractions_path', true);
                    }}
                  />
                } */}
                {
                  // (mapContext.zoom <= 14 && !isSingle ) ? <h5 style={{ color: 'white' }}>永靖旅遊地圖</h5> : <h5>永靖旅遊地圖</h5>
                  <h5>小旅行地圖平台</h5>
                }
                
              </div>
            </Layout>
            
          </div>
          
        </div>
       
      </div>
      
      <Footer
        className='w-full flex flex-col justify-end items-center p-0  absolute bottom-0 bg-transparent'
      // max-w-[550px] min-w-[375px]
      >
        {
          showCollapse ?
            <>
              <div className=" shadow-md shadow-gray-500 w-full rotate-180 h-1"></div>
              <Collapse 
              activeKey={isOpenPanel} 
              items={items} 
              defaultActiveKey={collapseActiveKey} 
              bordered={true} 
              onChange={onChange} 
              expandIconPosition={'end'} 
              className=' w-full bg-white '/>
                
            </> : ""
        }
       
      </Footer>
     
      </MobileLayout >
     
      } 
    </>
  )
};
export default MobilePage;
